/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from './header';
import Menu from './menu';
import * as binaryService from '../services/binaryService';
import ExpoPopup from './sub_components/expoPopup';
import BinaryBook from './binarybook'
import Toast from './sub_components/toast';
import BetSlipPopup from './sub_components/betSlipPopup';
import * as dateUtil from '../util/date.util'
// import * as utilService from '../services/utilService';
import * as authUtil from "../util/auth.util";

let mBets = []
let umBets = []
let dataUpdate = null

let formInterval
let socket = null
class Binary extends Component {
    constructor(props) {
        super(props);
        this.state = {
            infoHide: true,
            showFancy: true,
            accounts: '',
            binaryMarkets: [],//{'daily':[], '1hour':[], '2hour':[]},
            selectBinaryMarket: 'daily',
            symbolType: 'All',
            marketMsg: {},
            pinnedEvents: [],
            game: {},
            matched_bet: [],
            subscribedMarkets: [],
            showExpo: false,
            lineExpo: {},
            selected_market: null,
            selcted_bet_option: null,
            loadingBet: false,
            betLimit: 20,
            betLimitMobile: 10,
            betSlipOpen: false,
            deactivatMarkets: [],
            deactivatOrders: [],
            indx: 0,
            myCurrentPnL: 0,
            mktFeedBooks: {},
            showToast: false,
            toastMsg: "",
            toastType: "",
        };
    }

    async componentDidMount() {
        localStorage.removeItem("betForm");
        localStorage.removeItem("betExpo");
        let userData = localStorage.getItem("tokenData")
        userData = JSON.parse(userData)
        if (!(!!userData && !!userData.sub)) {
            authUtil.logout();
        }
        this.setState({ accounts: userData.sub }, () => {
            this.loadMatchedBets();
        })
        // this.loadBinaryList();
    }

    loadMatchedBets() {
        const self = this
        // let evtList = this.state.binaryMarkets.map(ev => ev.event.id)
        binaryService.getMatchedBets({ "id": "300" }).then((res) => {
            if (!!res && res.isSuccess) {
                mBets = []
                res.items.forEach((bet) => {
                    // bet.eventName = evetData.eventName
                    if (bet.marketBettingType === "LINE") {
                        bet.runnerName = bet.marketName
                    }
                    if (self.state.deactivatMarkets.indexOf(bet.marketId) === -1 && self.state.deactivatOrders.indexOf(bet.orderId) === -1) {
                        mBets.push(bet)
                    }
                })
                // mBets = mBets.reverse()
                self.setState({ matched_bet: [] },
                    () => {
                        self.setState({ matched_bet: mBets }, () => {
                            self.mapLiveRateAndCalculatePnL();
                        })
                    }
                )
            }
        })
    }

    async getEvtData(userEventCktData, userEventSocData, userEventTenData, userEventKbdData, userEventElectData, userEventHorseData, userEventHoundData, userEventBinaryData) {
        if (!userEventBinaryData) {
            return false
        }
        let binryData = userEventBinaryData
        binryData = binryData.filter((mkt) => {
            return mkt.catalogue.status !== "INACTIVE" && mkt.catalogue.status !== "CLOSED"
        })
        const mktsList = binryData.map((evt) => { return evt = evt.catalogue.marketId })
        let fancy_mkts = binryData.filter((mkt) => {
            return !!mkt.metadata && !!mkt.metadata.book && !!mkt.metadata.book.marketId && (mkt.metadata.book.status !== "CLOSED" && mkt.metadata.book.status !== "INACTIVE")
        })
        let pinnedEvents = localStorage.getItem("pinnedEvents")
        pinnedEvents = !!pinnedEvents ? pinnedEvents.split(",") : []
        this.setState({ pinnedEvents: pinnedEvents, game: fancy_mkts, binaryMarkets: fancy_mkts, mktsList: mktsList }, () => {
            this.mapLiveRateAndCalculatePnL();
        })
    }

    onChange(e, val = '') {
        const name = e.target.name;
        const value = e.target.value;
        this.setState({ [name]: value });
    }
    onMarketTypeTabClick(val = '') {
        this.setState({ selectBinaryMarket: val });
    }

    updateSubscribedMarkets(mkt) {
        let mktList = this.state.subscribedMarkets
        mktList.push(mkt)
        this.setState({ subscribedMarkets: mktList })
    }

    showExpo(data) {
        this.setState({ showExpo: true, lineExpo: data })
    }
    hidePopup() {
        this.setState({ showExpo: false, betSlipOpen: false, lineExpo: {} })
    }

    updateSocket(skt) {
        socket = skt
    }

    betForm(market, bet, clicked) {
        let self = this
        if (this.state.loadingBet === true) {
            return false
        }
        if (market === null && bet === null) {
            localStorage.removeItem("betForm");
            localStorage.removeItem("betExpo");
        }
        this.setState({ selected_market: market, selcted_bet_option: bet }, () => {
            if (market !== null && bet !== null && clicked) {
                if (window.innerWidth > 767) {
                    let screenHeight = window.innerHeight
                    let myBetForm = document.getElementById("betFormBtns").offsetTop
                    let myBetFormPt = document.getElementById("betFormBtns").parentNode.parentNode.offsetTop
                    if ((myBetFormPt + myBetForm) > (window.scrollY + (screenHeight / 2))) {
                        window.scrollTo(0, window.scrollY + 70)
                    }
                } else {
                    let screenHeight = window.innerHeight
                    let myBetForm = document.getElementById("betFormBtnsMob").offsetTop
                    let myBetFormPt = document.getElementById("betFormBtnsMob").parentNode.parentNode.offsetTop
                    if ((myBetFormPt + myBetForm) > (window.scrollY + (screenHeight / 2))) {
                        window.scrollTo(window.scrollY, window.scrollY + 235)
                    }
                }
            }
            clearTimeout(formInterval)
            formInterval = setTimeout(function intetvalBetForm() {
                if (self.state.selected_market === market && self.state.selcted_bet_option === bet) {
                    self.betForm(null, null)
                }
            }, 10000)
        })
    }

    addBet(bet) {
        this.setState({ loadingBet: true })
        bet.event_name = bet.market.event.name
        bet.competition_Name = bet.market.competition.name
        let betData = JSON.parse(localStorage.getItem("betForm"))
        let body = {
            marketId: bet.marketId,
            placeInstruction: {
                orderType: "LIMIT",
                selectionId: parseFloat(betData.selectionId),
                side: !!bet.bet_for ? bet.bet_for.toUpperCase() : 'UNKNOWN',
                limitOrder: {
                    size: parseFloat(parseFloat(betData.bid_amount.toString()).toFixed(2)),
                    price: parseFloat(parseFloat(betData.bid_at.toString()).toFixed(2)),
                    persistenceType: "PERSIST"
                }
            }
        }
        if (!!betData.bid_line && betData.bid_line > 0) {
            body.placeInstruction.selectionId = parseFloat(betData.bid_line)
        }
        binaryService.placeOrder(body).then((res) => {
            if (res.isSuccess !== false && !res.errors) {
                if (!!res.exception && !!res.exception.message) {
                    this.props.notify(res.exception.message, "error")
                } else {
                    this.props.notify("Bet Placed Successfully !", "success")
                    if (!!res.data && Object.keys(res.data).length > 0) {
                        this.orderPlaced(res.data, bet)
                    }
                }
                setTimeout(() => {
                    this.setState({ selected_market: "", selcted_bet_option: "", loadingBet: false })
                }, bet.market.betDelay)
            } else {
                this.setState({ selected_market: "", selcted_bet_option: "", loadingBet: false })
                this.props.notify(!!res.exception && !!res.exception.message ? res.exception.message : "Bet failed due to mismatch data.", "error")
            }
        })
    }
    updateBook(marketId, book) {
        let feedBooks = this.state.mktFeedBooks
        feedBooks[marketId] = book
        this.state.mktFeedBooks = feedBooks
        let mktt = null;
        for (const mkt of this.state.binaryMarkets) {
            if (marketId === mkt.catalogue.marketId) {
                mktt = Object.assign({}, mkt)
                mktt.metadata.book = book
                break;
            }
        }
        if (!!mktt) {
            this.mapLiveRateAndCalculatePnL(mktt);
        }
    }
    toggleMultiMarket(eventId) {
        let pinnedEvents = localStorage.getItem("pinnedEvents")
        pinnedEvents = !!pinnedEvents ? pinnedEvents.split(",") : []
        let eventIndex = pinnedEvents.indexOf(eventId)
        if (eventIndex === -1) {
            pinnedEvents.push(eventId)
        } else {
            pinnedEvents.splice(eventIndex, 1)
        }
        localStorage.setItem("pinnedEvents", pinnedEvents.toString())
        this.setState({ pinnedEvents: pinnedEvents })
    }
    orderPlaced(ord, bet) {
        let res = [ord]
        if (res[0].marketBettingType === "LINE" && res[0].marketName) {
            res[0].runnerName = res[0].marketName
        }
        let deactivatMarkets = this.state.deactivatMarkets
        let deactivatOrders = this.state.deactivatOrders
        let data = res.concat(this.state.matched_bet)
        data = data.filter((bet) => {
            return deactivatMarkets.indexOf(bet.marketId) === -1
        })
        data = data.filter((bet) => {
            return deactivatOrders.indexOf(bet.orderId) === -1
        })
        this.setState({ matched_bet: data, betPlaced: true }, () => {
            this.mapLiveRateAndCalculatePnL(bet.market);
        })
    }

    async resultDeclered(type, payload) {
        let deactivatMarkets = this.state.deactivatMarkets
        let deactivatOrders = this.state.deactivatOrders
        let matchedBets = this.state.matched_bet

        if (type === "market") {
            if (!!payload && !!payload.marketId) {
                deactivatMarkets.push(payload.marketId)
            }
            matchedBets = matchedBets.filter((bet) => {
                return deactivatMarkets.indexOf(bet.marketId) === -1
            })
        }
        else if (type === "order") {

            if (!!payload && !!payload.orderId) {
                deactivatOrders.push(payload.orderId)
            }
            matchedBets = matchedBets.filter((bet) => {
                return deactivatOrders.indexOf(bet.orderId) === -1
            })
        }
        else if (type === "rollback") {

            let index = deactivatMarkets.indexOf(payload.marketId)
            if (index > -1) {
                deactivatMarkets.splice(index, 1)
            }
            this.loadMatchedBets();
        }

        this.setState({ matched_bet: matchedBets, deactivatMarkets: deactivatMarkets, deactivatOrders: deactivatOrders }, () => {
            this.mapLiveRateAndCalculatePnL();
        })
    }
    arrayGroupBy(ary, attr) {
        let group = ary.reduce((r, a) => {
            r[a['catalogue'][attr]] = [...r[a['catalogue'][attr]] || [], a];
            return r;
        }, {});
        return group
    }
    organizedBinary(markets) {
        if (!markets) {
            return {}
        }
        let newObj = {}

        if (!!markets["DAILY"]) {
            newObj["DAILY"] = markets["DAILY"]
            delete markets["DAILY"]
        }
        if (!!markets["1HOUR"]) {
            newObj["1HOUR"] = markets["1HOUR"]
            delete markets["1HOUR"]
        }
        if (!!markets["2HOUR"]) {
            newObj["2HOUR"] = markets["2HOUR"]
            delete markets["2HOUR"]
        }
        newObj = { ...newObj, ...markets }
        let fancys = []
        Object.keys(newObj).forEach((type) => {
            newObj[type] = newObj[type].sort((a, b) => {
                return a.sortPriority - b.sortPriority;
            });
            fancys = fancys.concat(newObj[type])
        })
        return fancys
    }
    binaryFilterApply(mktList) {
        let filter = this.state.selectBinaryMarket
        // if (filter !== "all") {
        mktList = mktList.filter((mkt, i) => {
            return mkt.catalogue.marketType.toLowerCase() === filter.toLowerCase()
        })
        // }
        return mktList
    }
    filterSelectBinaryMarketList(binaryMarkets) {
        let selectBinaryMarketList_data = binaryMarkets;
        if (this.state.symbolType !== "All") {
            selectBinaryMarketList_data = selectBinaryMarketList_data.filter((BinMkt) => {
                return BinMkt.symbolType.toLowerCase() === this.state.symbolType.toLowerCase();
            });
        }
        return selectBinaryMarketList_data;
    }

    mapLiveRateAndCalculatePnL(mkt = null) {
        let betsList = this.state.matched_bet;
        let totalPnL = 0;
        if (!!mkt) {
            for (let bet of betsList) {
                if (bet.marketId === mkt.catalogue.marketId) {
                    // bet['market_time'] = !!mkt.displayMarketNameTime && mkt.displayMarketNameTime.length > 0 ? mkt.displayMarketNameTime : []
                    bet['liveRate'] = mkt.metadata.book.runners[0]['back'][0].line;
                    if (bet.side.toLowerCase() === 'back') {
                        if (parseFloat(bet.runnerId) <= parseFloat(mkt.metadata.book.runners[0]['back'][0].line)) {
                            bet['pnl'] = (parseFloat(bet.price) / 100) * parseFloat(bet.amount);
                        } else {
                            bet['pnl'] = 0 - parseFloat(bet.amount);
                        }
                    } else {
                        if (parseFloat(bet.runnerId) > parseFloat(mkt.metadata.book.runners[0]['back'][0].line)) {
                            bet['pnl'] = parseFloat(bet.amount)
                        } else {
                            bet['pnl'] = 0 - ((parseFloat(bet.price) / 100) * parseFloat(bet.amount));
                        }
                    }
                }
                if (!!bet['pnl']) {
                    totalPnL += bet['pnl'];
                }
            }
        } else {
            for (let bet of betsList) {
                for (let bnymkt of this.state.binaryMarkets) {
                    if (bet.marketId === bnymkt.catalogue.marketId) {
                        // bet['market_time'] = !!bnymkt.displayMarketNameTime && bnymkt.displayMarketNameTime.length > 0 ? bnymkt.displayMarketNameTime : []
                        bet['liveRate'] = bnymkt.metadata.book.runners[0]['back'][0].line;
                        if (bet.side.toLowerCase() === 'back') {
                            if (parseFloat(bet.runnerId) <= parseFloat(bnymkt.metadata.book.runners[0]['back'][0].line)) {
                                bet['pnl'] = (parseFloat(bet.price) / 100) * parseFloat(bet.amount);
                            } else {
                                bet['pnl'] = 0 - parseFloat(bet.amount);
                            }
                        } else {
                            if (parseFloat(bet.runnerId) > parseFloat(bnymkt.metadata.book.runners[0]['back'][0].line)) {
                                bet['pnl'] = parseFloat(bet.amount)
                            } else {
                                bet['pnl'] = 0 - ((parseFloat(bet.price) / 100) * parseFloat(bet.amount));
                            }
                        }
                        break;
                    }
                }
                if (!!bet['pnl']) {
                    totalPnL += bet['pnl'];
                }
            }
        }
        this.setState({ matched_bet: [], myCurrentPnL: 0 }, () => {
            this.setState({ matched_bet: betsList, myCurrentPnL: totalPnL })
        })
    }
    showToast(msg, type) {
        let self = this
        this.setState({ toastMsg: msg, toastType: type, showToast: true }, () => {
            setTimeout(() => {
                self.setState({ toastMsg: "", toastType: "", showToast: false })
            }, 3000);
        })
    }
    render() {
        let bnyMarkets = this.arrayGroupBy(this.state.binaryMarkets, "marketType")
        bnyMarkets = this.organizedBinary(bnyMarkets)
        let bmkt = this.arrayGroupBy(bnyMarkets, "marketType")
        let maketTypeList = Object.keys(bmkt).map((bny, i) => { return bny = { mkt: bny, count: bmkt[bny].length } })
        bnyMarkets = this.binaryFilterApply(bnyMarkets);
        const filteredSelectBinaryMarketList = this.filterSelectBinaryMarketList(bnyMarkets);
        let bet_list = this.state.matched_bet
        let accData = JSON.parse(localStorage.getItem("accountData"));
        return (
            <body className="radheexch">
                <Header notify={this.props.notify} showSweetAlert={(options) => this.props.showSweetAlert(options)} MySwal={this.props.MySwal} updateBetplaceStatus={() => { this.setState({ betPlaced: false }) }} betPlaced={this.state.betPlaced} subscribe={(type, id) => { this.props.subscribe(type, id) }} subscriptions={this.props.subscriptions} history={this.props.history} socket={this.props.socket} updateSocket={(skt) => { this.updateSocket(skt) }} getEvtData={(ckt, soc, ten, kbd, elc, hor, hou, bin) => { this.getEvtData(ckt, soc, ten, kbd, elc, hor, hou, bin) }} resultDeclered={(type, payload) => { this.resultDeclered(type, payload) }} orderPlaced={(ord) => { this.orderPlaced(ord) }} />
                <div className={`full-wrap mar-top100 footerpd ${(!!accData && Object.keys(accData).length > 0) ? '' : 'mar-top100-login mar-bottom0'}`}>
                    <Menu history={this.props.history} />
                    {!!this.state.showToast && <Toast notification={this.state.toastMsg} type={this.state.toastType} />}
                    <div className="col-centersdetails markets">
                        <div className="daily-session">
                            <div className=" live-match">
                                <div className="sub_path center-box crname">
                                    <p>
                                        <span>Binary Session</span>
                                        <span className="fancyplus-icon f-right lheight fancyplus-icon-binary " style={{ color: "white" }}><a onClick={() => { this.setState({ showFancy: !this.state.showFancy }) }}>{this.state.showFancy ? <i className="fa fa-minus" aria-hidden="true"></i> : <i className="fa fa-plus" aria-hidden="true"></i>}</a></span>
                                    </p>
                                </div>
                                <div className="sub_path center-box binarybg">
                                    <ul className="fancy-filter binarybg">

                                        {maketTypeList.map((bny) => {
                                            return (<li key={bny.mkt}><a className={this.state.selectBinaryMarket.toLowerCase() === bny.mkt.toLowerCase() ? "active" : ""} onClick={(e) => { this.onMarketTypeTabClick(bny.mkt.toLowerCase()) }}>{bny.mkt.replace('_', ' ')}<span className="fancynew-budge">{bny.count}</span></a></li>)
                                        })
                                        }
                                    </ul>
                                    {/* <span className="fancyplus-icon" style={{color:"white"}}>
                                        <a><i className="fa fa-minus" aria-hidden="true"></i></a>
                                    </span> */}
                                </div>
                                <div className="fancybgmobile">
                                    <div className=" fancyscrollmenu binaryscrollmenu">
                                        {maketTypeList.map((bny) => {
                                            return (<a key={bny.mkt + 'a'} className={this.state.selectBinaryMarket.toLowerCase() === bny.mkt.toLowerCase() ? "active" : ""} onClick={(e) => { this.onMarketTypeTabClick(bny.mkt.toLowerCase()) }}>{bny.mkt.replace('_', ' ')}<span className="fancynew-budge">{bny.count}</span></a>)
                                        })}

                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="live-match" style={{ display: this.state.showFancy ? "block" : "none" }}>
                                    <div className="game-wrap col3 binarytable">
                                        <table className="table w-100 game-list-col fancytable mb-0">
                                            <tbody>
                                                <tr className="bet-all-new">
                                                    <td>
                                                        {/* <span className="binasytitle">03:30:00 To 22:30:00</span> */}
                                                        <div className="form-group binaryw-25 d-inline-block mb-0 m-1  ">
                                                            <select className="form-control binarydrop" title="symbolType" name="symbolType" value={this.state.symbolType} onChange={(e) => { this.onChange(e) }}>
                                                                <option value="All">All</option>
                                                                <option value="FUTURES">FUTURES</option>
                                                                <option value="COMEX">COMEX</option>
                                                                <option value="INDICES">INDICES</option>
                                                                <option value="STOCK">STOCK</option>
                                                                <option value="WORLD INDICES">WORLD INDICES</option>
                                                            </select>
                                                        </div>
                                                    </td>
                                                    <td className="w-16 pb-0">
                                                        <div>
                                                            <div className=""><a id="btnBack" className="btn-back bg-trans" side="Back"><span>No</span></a>
                                                            </div>
                                                            <div><a id="btnLay" className="btn-lay bg-trans" side="Lay"><span>Yes</span></a>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    {/* <td className="w-12 pb-0 text-left"> <span className="binasytitle">Results</span> </td> */}
                                                    <td className="w-16 mobile-hide pb-0"> &nbsp; </td>
                                                </tr>
                                                {/* <tr className="brblumobile">
                                                    <td colSpan="3">
                                                        <div className="w-100">
                                                            <a className="add-pin-d mr-1" title="Add to Multi Markets" style={{cursor:"pointer"}}></a>
                                                            <span className="in-play-title-m">Bank Nifty </span>
                                                            <a onClick={() => { this.setState({ infoHide: false }) }} className="dhide float-right"><i className="fa fa-info-circle" aria-hidden="true"></i></a>
                                                            </div>
                                                            {!this.state.infoHide && <div className="mobile-show" style={{ background: "#ccdddd", padding: "5px", borderRadius: "5px", position: "absolute", width: "94%", zIndex: "1" }}>
                                                                <span className="d-block "> Max:<span>100</span> |  Max Profit:<span>10000</span><span onClick={() => { this.setState({ infoHide: true }) }} style={{ marginRight: 5, cursor: "pointer" }} className="float-right">X</span></span>
                                                            </div>}
                                                    </td>
                                                </tr> */}

                                                {/* <tr key="123">
                                                                <td className="fancyw-50">
                                                                <span className="in-play-title ">
                                                                <a className="add-pin-d mr-1" title="Add to Multi Markets" style={{cursor:"pointer"}}></a>
                                                                    <a className="dhide mfancyhideshow"><i className="fa fa-info-circle" aria-hidden="true"></i></a>
                                                                    <span className="mfancyhideshow" title=""  style={{ fontWeight: "bold", cursor: "pointer", fontFamily: "tahomabd" }}>Bank Nifty</span>
                                                                    <span className="match-odds font-weight-bold" style={{color:"red"}}>-112200.00</span>
                                                                </span>
                                                                <span className="wid250fancy"><span className="fancymassage"><i className="fa fa-envelope mr-1"></i>Test msg</span></span>
                                                                </td>
                                                                <td className="w-16">
                                                                    <div className="">
                                                                        <div>
                                                                            <a id="btnLay" className="btn-lay" side="Lay" style={{ MinHeight: "36px" }}>
                                                                                <div style={{ MinHeight: "12px" }}>45854</div><span className="ask-price-small">115</span>
                                                                            </a>
                                                                        </div>
                                                                        <div>
                                                                            <a id="btnBack" className="btn-back" side="Back" style={{ MinHeight: "36px" }}>
                                                                                <div style={{ MinHeight: "12px" }}>45874</div><span className="bid-price-small">85</span>
                                                                            </a>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td className="w-16 mobile-hide">
                                                                    <div className="min-max-price">
                                                                        <span className="d-block">Max:<span>100K</span></span>
                                                                        <span className="d-block">MKT:<span>1000K</span></span>
                                                                    </div>
                                                                </td>
                                                            </tr>  */}
                                                {(filteredSelectBinaryMarketList && filteredSelectBinaryMarketList.length > 0) &&
                                                    filteredSelectBinaryMarketList.map((binmkt, i) => {
                                                        let isMsg = !!this.state.marketMsg && !!this.state.marketMsg[binmkt.catalogue.marketId] ? this.state.marketMsg[binmkt.catalogue.marketId] : []
                                                        return <BinaryBook key={`binarybook_${binmkt.catalogue.marketId}`} isEventUpdate={this.state.isEventUpdate} subscribe={(type, id) => { this.props.subscribe(type, id) }} subscriptions={this.props.subscriptions} subscribedMarkets={this.state.subscribedMarkets} updateSubscribedMarkets={(binmkt) => { this.updateSubscribedMarkets(binmkt) }} feedBooks={this.state.mktFeedBooks} updateBook={(marketId, book) => { this.updateBook(marketId, book) }} loadingBet={this.state.loadingBet} socket={socket} showExpo={(data) => { this.showExpo(data) }} curBets={bet_list} index={i} type={"ses"} notify={(msg, type) => { this.props.notify(msg, type) }} addBet={(bet) => { this.addBet(bet) }} selected_market={this.state.selected_market} selcted_bet_option={this.state.selcted_bet_option} msgMarket={isMsg.length > 0 ? isMsg[isMsg.length - 1].message : ""} betForm={(market, bet, clicked) => { this.betForm(market, bet, clicked) }} market={binmkt} toggleMultiMarket={(marketId) => { this.toggleMultiMarket(marketId) }} pinnedEvents={this.state.pinnedEvents} />

                                                    })
                                                }
                                                <tr>
                                                    <td colSpan="4"><span className="binasytitle text-right w-100 bmmassage" style={{ cursor: 'text' }}>Result Will be declared on Exchange's ASK Price only.</span></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="live-match livetv">
                                <a href="#openbetscount" className="d-block">
                                    <div className="center-box mt-1">
                                        <div className="container-fluid titbg">
                                            <div className="w-100 float-left">
                                                <span className="betslip-btn active">Matched Bet</span>
                                                {bet_list.length > this.state.betLimitMobile && <a className="view-more-btn" onClick={() => { this.setState({ betSlipOpen: true }) }} data-toggle="modal" data-target="#mystatement">View More</a>}
                                            </div>
                                        </div>
                                        <div className="mybet-alldata bg-white table-responsive">
                                            <table className="table table-bordered nowrap table-sm font-12 mb-4">
                                                <thead>
                                                    <tr className="bg-dark text-white">
                                                        <th>Matched Bet</th>
                                                        <th>Odds</th>
                                                        <th>Stake</th>
                                                        <th>Liverate</th>
                                                        <th>P/L</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr colSpan="5">
                                                        <td className="binasytitle" style={{ borderRight: "0" }}>My Current P/L: <span className={this.state.myCurrentPnL < 0 ? "ml-1 binasytitle text-danger" : "ml-1 binasytitle text-success"}>{this.state.myCurrentPnL}</span></td>
                                                    </tr>
                                                    {bet_list.length > 0 && bet_list.map((bet, i) => {
                                                        bet['market_time'] = !!bet.marketName ? dateUtil.getBinaryMarketDisplayName(bet.marketName) : []
                                                        return (
                                                            <>
                                                                {i < this.state.betLimitMobile && <tr key={`inner_${i}`} className={bet.side === "LAY" ? "lay-bg" : "back-bg"}>
                                                                    <td>{(!!bet.market_time && bet.market_time.length > 0 ? bet.market_time[0] : bet.marketName)} {!!bet.market_time && bet.market_time.length > 0 && <small className='float-right'><b>[{bet.market_time[1]}]</b></small>}</td>
                                                                    <td>{bet.marketBettingType === "LINE" ? bet.runnerId : bet.price}</td>
                                                                    <td>{bet.amount ? bet.amount.toFixed(2) : "0.00"}</td>
                                                                    <td>{bet.liveRate}</td>
                                                                    <td><span className={!!bet.pnl && parseFloat(bet.pnl) < 0 ? "text-danger" : "text-success"}>{parseFloat(bet.pnl).toFixed(2)}</span></td>
                                                                </tr>}
                                                            </>
                                                        )
                                                    })
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className={`col-right ${(!!accData && Object.keys(accData).length > 0) ? '' : 'col-right-login'}`}>
                        <div className="sub_path over-wrap">
                            <div className="center-box">
                                <div className="container-fluid titbg">
                                    <div className="w-100 float-left">
                                        <span className="betslip-btn active">Matched Bet</span>
                                        {bet_list.length > this.state.betLimit && <a className="view-more-btn" onClick={() => { this.setState({ betSlipOpen: true }) }} data-toggle="modal" data-target="#mystatement">View More</a>}
                                    </div>
                                </div>
                                <div className="mybet-alldata bg-white table-responsive">
                                    <table className="table table-bordered nowrap table-sm font-12 mb-4">
                                        <thead>
                                            <tr className="bg-dark text-white">
                                                <th>Matched Bet</th>
                                                <th>Odds</th>
                                                <th>Stake</th>
                                                <th>Liverate</th>
                                                <th>P/L</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr colSpan="5">
                                                <td className="binasytitle" style={{ borderRight: "0" }}>My Current P/L: <span className={this.state.myCurrentPnL < 0 ? "ml-1 binasytitle text-danger" : "ml-1 binasytitle text-success"}>{this.state.myCurrentPnL}</span></td>
                                            </tr>
                                            {/* <tr className="back-bg">
                                                <td>BankNifty</td>
                                                <td>37500</td>
                                                <td>100</td>
                                                <td>37600</td>
                                                <td>1000</td>
                                            </tr>
                                            <tr className="lay-bg">
                                                <td>BankNifty</td>
                                                <td>37500</td>
                                                <td>100</td>
                                                <td>37600</td>
                                                <td>1000</td>
                                            </tr> */}
                                            {bet_list.length > 0 && bet_list.map((bet, i) => {
                                                bet['market_time'] = !!bet.marketName ? dateUtil.getBinaryMarketDisplayName(bet.marketName) : []
                                                return (
                                                    <>
                                                        {i < this.state.betLimit && <tr key={`outter_${i}`} className={bet.side === "LAY" ? "lay-bg" : "back-bg"}>
                                                            <td>{(!!bet.market_time && bet.market_time.length > 0 ? bet.market_time[0] : bet.marketName)} {!!bet.market_time && bet.market_time.length > 0 && <small className='float-right'><b>[{bet.market_time[1]}]</b></small>}</td>
                                                            <td className='text-right'>{bet.marketBettingType === "LINE" ? bet.runnerId : bet.price}</td>
                                                            <td className='text-right'>{bet.amount ? bet.amount.toFixed(2) : "0.00"}</td>
                                                            <td className='text-right'>{bet.liveRate}</td>
                                                            <td className='text-right'><span className={!!bet.pnl && parseFloat(bet.pnl) < 0 ? "text-danger" : "text-success"}><b>{parseFloat(bet.pnl).toFixed(2)}</b></span></td>
                                                        </tr>}
                                                    </>
                                                )
                                            })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    {this.state.showExpo && <ExpoPopup lineExpo={this.state.lineExpo} hidePopup={() => { this.hidePopup() }} />}
                    {this.state.betSlipOpen && <BetSlipPopup bets={bet_list} eventTypeId={"300"} hidePopup={() => { this.hidePopup() }} />}
                </div>
                {/* <div id="openbetscount" className="binaryorder">
                    <span className="openordercount">Open Bets <span className="badge badge-pill badge-warning">15</span></span>
                </div> */}
            </body>
        )
    }
}
function mapStateToProps(state) {
    return {
    };
}
function mapDispatchToProps(dispatch) {
    return {
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(Binary);